<template>
    <div class="obras container pb-4">
        <h2 class="text-center">Actividades de Visual Merchandising</h2>
        <hr>
        <div class="row d-flex justify-content-center">
            <div class="col-md-12">
                 <h4>Fundamento</h4>
             <p class="studio-p"> Hoy en día en el mundo retail solo gana el que logra conectar con su público y el que le ofrece gratas experiencias, diferenciándose de las demás opciones.
                Por ello es fundamental aplicar esta herramienta, que logra la gestión exitosa de cualquier establecimiento comercial.</p>
            </div>
        </div>
        <div class="row">
           <div v-for="(item,i) in items" :key="i"   class="col-md-3">
               <router-link v-if="item.activo == 'activo'" :to="`/curso/curso/${item.id}`" tag="a" class="box-studio text-center">
                   <a href="">{{item.titulo}}</a>
               </router-link >
               <div v-else class="box-studio text-center">
                     <div class="no-link">{{item.titulo}}</div>
               </div>
           </div>  
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            items:[]
        }
    },
    methods:{
        loadLogs () {
       this.$http.get(`https://espais.com.py/admin/api/1.1/tables/cursos/rows?filters[tipo][in]=visual`)
        .then(function (data) {
            console.log(data.body.data);
            this.items = data.body.data;
      
        })
      }
    },
      mounted () {
        this.$nextTick(function () {
        this.loadLogs();
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/cursos/Visual.vue